export default function getResource(label, vars = []) {
    const resources = {
        promoWarning: 'Promo/Reward Code Warning',
        promoConfirmationTitle: 'Promotion Redeemed',
        promoConfirmationMessage: 'Your promotion has been added to your basket.',
        ok: 'OK',
        promoErrorTitle: 'Promo Error',
        promoOopsTitle: 'Oops!',
        gotIt: 'Got It',
        oops: 'Oops!',
        gwpErrorMessage: 'We\'re unable to load gift options at this time. Please try again later.',
        gwpConfigError: 'This promotion is not properly configured. Please contact customer service or try again later.',
        noGwpAvailable: 'No gift options are currently available. Please try again later.'
    };

    return resources[label];
}
